import '../../css/LabeledOption.less';

import React from 'react';
import {Popup} from 'semantic-ui-react';
import makeComp from '../../util/profiler';

interface LabeledOptionProps {
  label: string;
  option: React.ReactNode;
  helpText?: string;
  docUrl?: string;
}
const LabeledOption: React.FC<LabeledOptionProps> = makeComp(
  props => {
    /*
  Doesn't really work to have link in a popup, but would be nice to give users a way to 
  quickly get to the docs.

    const helpWithLink =
    props.docUrl != null ? (
      <span>
        {props.helpText}
        <a href={props.docUrl} target="_blank" rel="noopener noreferrer">
          Learn More
        </a>
      </span>
    ) : (
      <span>{props.helpText}</span>
    );
    */
    const popupLabel =
      props.helpText != null ? (
        <Popup
          inverted
          size="mini"
          trigger={<span className="option-label">{props.label}</span>}
          content={props.helpText}
        />
      ) : (
        <span className="option-label">{props.label}</span>
      );

    return (
      <div className="labeled-option-block">
        {popupLabel}
        <div className="option">{props.option}</div>
      </div>
    );
  },
  {id: 'LabeledOption'}
);

export default LabeledOption;
